export const checkValidity = (
    input,
    reportValidity,
    controllerProp = '_validationController',
    internalsProp = '_internals'
) => {
    const controller = input[controllerProp];
    const isValid = controller.validate();

    input.toggleAttribute('error', !isValid);
    if (!isValid) {
        input.setAttribute('error-text', controller.getErrorMessage());
    } else {
        input.removeAttribute('error-text');
    }

    if (!isValid && reportValidity) {
        const internals = input[internalsProp];
        internals.reportValidity();
    }

    return isValid;
};
